<script setup>
import { get_option } from '@/services/option';
import { swalError } from '@/helper';
import { onMounted, ref } from 'vue';

const isLoading = ref(true)
onMounted(async()=>{
  await get_latest_info()
  isLoading.value = false
})

const info = ref('')
async function get_latest_info(){
  let response = await get_option('latest_information')
  // console.log("🚀 ~ get_latest_info ~ response:", response)
  if (response.error){
    swalError(response.result, true)
    return
  }
  info.value = parseInfo(response.result.data.attributes.name)
}

function parseInfo(result){
  if (result == ''){
    return { title: '', description: ''}
  }
  let data = JSON.parse(result)
  
  // Convert http/https URLs to clickable links and avoid matching trailing punctuation
  const urlRegex = /(https?:\/\/[^\s<]+[^<.,:;"')\]\s])/g;
  let linkedDescription = data.description.replace(urlRegex, '<a href="$1" target="_blank" class="text-primary text-decoration-underline" rel="noopener noreferrer">$1</a>')
  
  // Replace newlines with <br /> for HTML rendering
  let filteredDescription = linkedDescription.replace(/\r?\n/g, '<br />')
  
  return { title: data.title, description: filteredDescription}
}
</script>

<template>
  <loadingCard v-if="isLoading"/>
  <div v-else class="card">
    <div class="card-header d-flex align-items-center justify-content-between">
      <h5>Latest Information</h5>
      <router-link :to="{name: 'general-setting'}" 
        class="text-secondary"
      >
        <vue-feather type="edit-3" class="fs-6"></vue-feather>
      </router-link>
    </div>
    <div class="card-body">
      <div class="info-content-scroll">
        <h4>{{ info.title }}</h4>
        <p v-html="info.description" />
      </div>
    </div>
  </div>
</template>

<style scoped>
.info-content-scroll {
  height: 400px;
  overflow-y: auto;
  padding-right: 10px; /* Avoid scrollbar covering text */
}

/* Optional: Custom scrollbar styling for better aesthetics */
.info-content-scroll::-webkit-scrollbar {
  width: 6px;
}
.info-content-scroll::-webkit-scrollbar-track {
  background: #f1f1f1; 
}
.info-content-scroll::-webkit-scrollbar-thumb {
  background: #c1c1c1; 
  border-radius: 3px;
}
.info-content-scroll::-webkit-scrollbar-thumb:hover {
  background: #a8a8a8; 
}
</style>